export default __webpack_public_path__ + "static/media/cancer5.42b3b75e.jpg";